import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useAntrian } from "./context";
import { useAlert, positions } from "react-alert";

function CariNikTab() {
  const { state, dispatch } = useAntrian();
  const alert = useAlert();
  const [data, setData] = useState({
    nik: "",
  });

  const submitHandler = async (e) => {
    if (e) {
      e.preventDefault();
    }
    try {
      dispatch({
        type: "LOADING",
      });
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/internal/search-antrian`,
        { ...data, key: process.env.REACT_APP_API_KEY }
      );
      dispatch({
        type: "SET_IDENTITAS",
        data: res.data,
        data: {
          nik: res.data.nik ?? data.nik,
          name: res.data.name ?? "",
          avatar: res.data.avatar ?? "",
          phone: res.data.phone ?? "",
          email: res.data.email ?? "",
        },
      });
    } catch (error) {
      alert.error("Terjadi kesalahan sistem. Silakan coba lagi.", {
        position: positions.TOP_CENTER,
      });
      dispatch({
        type: "STOP_LOADING",
      });
    }
  };

  const inputChangeHandler = (event) => {
    setData((prev) => ({
      ...prev,
      [event.target.name]: event.target.value,
    }));
  };
  useEffect(() => {
    dispatch({
      type: "ENABLE_CTA",
    });
  }, []);

  const ctaRef = useRef(null);

  return (
    <form onSubmit={submitHandler} autoComplete="off">
      <div className="row">
        <div
          className="form-group"
          style={{
            width: "100%",
          }}
        >
          <label>Nomor Induk Kependudukan</label>
          <input
            type="number"
            name="nik"
            value={data.nik}
            onChange={inputChangeHandler}
          />
        </div>
      </div>
      <div className="row">
        <button
          type="submit"
          className="cta"
          disabled={state.ctaDisabled}
          ref={ctaRef}
        >
          Lanjutkan
        </button>
      </div>
    </form>
  );
}
export default CariNikTab;
